<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">スキル設定</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="showCreateFormDialog">スキル追加</button>
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<table id="shop_skill_attribute_table" class="uk-table uk-table-expand uk-table-striped">
				<thead>
				<tr>
					<th>NO.</th>
					<th>スキル名</th>
					<th>有効<br><span style="color: #b9e0d9">※一括選択できます</span><br><input id="bulk_check_action" class="uk-checkbox" type="checkbox" @click="bulkCheckAction"></th>
					<th>更新日</th>
				</tr>
				</thead>
				<tbody>
				<template v-for="(shop_skill_attribute, index) in shop_skill_attributes">
					<tr class="data_row" :key="index" :data-id="shop_skill_attribute.id">
						<td>{{ shop_skill_attribute.id }}</td>
						<td>{{ shop_skill_attribute.skill_attribute.name }}</td>
						<template v-if="shop_skill_attribute.status == 0">
							<td><input class="uk-checkbox" name="status" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="status" type="checkbox"></td>
						</template>
						<td>{{ shop_skill_attribute.updated_at | moment }}</td>
					</tr>
				</template>
				<tr>
					<td>
						<button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button>
					</td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				</tbody>
			</table>
			<div class="uk-container uk-container-expand uk-margin-small-bottom">
				<div class="uk-align-right">
					<button class="uk-button uk-button-primary" @click="saveEditShopSkillAttribute">保存</button>
				</div>
			</div>
		</div>
		<!--/ Main -->
		<!-- CreateFormDialog -->
		<div id="create_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_skill_attribute_name">スキル名 (必須)</label>
							<div class="uk-form-controls">
								<select id="create_form_skill_attribute_name" class="uk-select" name="skill_attribute">
									<template v-for="(skill_attribute, index) in skill_attributes">
										<option :key="index" :value="skill_attribute.id">{{ skill_attribute.name}}</option>
									</template>
								</select>
								<template v-if="typeof this.createFormState.errors.skill_attribute_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.skill_attribute_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateFormDialog -->
	</div>
</template>

<script>

	import StaffAuth from '@/api/StaffAuth'
	import ShopSkillAttribute from '@/api/ShopSkillAttribute'
	import SkillAttribute from '@/api/SkillAttribute'
	import Role from '@/api/Role'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'

	export default {
		name: 'SkillAttributeMasterPage',
		data () {
			return {
				need_confirm_alert: false,
				current_staff: null,
				skill_attributes: [],
				shop_skill_attributes: [],
				createFormState: {
					errors: []
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/shop')
						location.reload()
					}
				} else {
					this.$router.push('/shop')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#shop_skill_attribute_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#shop_skill_attribute_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditShopSkillAttribute () {
				let self = this
				let length = $('#shop_skill_attribute_table .data_row_before_save').length

				$('#shop_skill_attribute_table .data_row_before_save').each(function (i) {
					let index = i

					let id = $(this).data('id')
					let status = 1

					if ($(this).find('[name="status"]').prop('checked')) {
						status = 0
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('status', status)

					ShopSkillAttribute.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							location.reload()
						}
					})
				})
			},
			saveCreateForm () { // ダイアログ保存
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data
					let skill_attribute_id = $('#create_form [name="skill_attribute"]').val()

					let params = new URLSearchParams()
					params.append('skill_attribute_id', skill_attribute_id)
					params.append('shop_id', staff.shop_id)

					ShopSkillAttribute.create(params).then(function (response) {
						alert('保存完了')
						location.reload()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			loadShopSkillAttributes () {
				let self = this

				StaffAuth.current().then(function (response) {
					return response.data.data
				}).then(function (staff) {
					let params = new URLSearchParams()
					params.append('shop_id', staff.shop_id)

					ShopSkillAttribute.all(params).then(function (response) {
						self.shop_skill_attributes = response.data.data
					})
				})
			},
			loadSkillAttributes () {
				let self = this
				let params = new URLSearchParams()
				params.append('status', 0)

				SkillAttribute.all(params).then(function (response) {
					self.skill_attributes = response.data.data
				})
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#shop_skill_attribute_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			}
		},
		created () {
			this.registerDataChangeEvent()
			this.loadSkillAttributes()
			this.loadShopSkillAttributes()
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_form_dialog')).hide()
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}

				self.need_confirm_alert = false
			})

			$('#create_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#shop_skill_attribute_table {
		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ShopSkillAttributeMasterPage.vue